import { Link } from 'react-router-dom';

import Button from 'ui/Button';
import Icon from 'ui/Icon';
import { Box, Flex, HStack } from 'ui/Layout';
import Tooltip from 'ui/Tooltip';

import { useSankeyFormContext } from '../../contexts/sankeyFormContext';
import {
  pathToSankeyPreview,
  useCurrentRouteSankeyId,
} from '../../utils/routes';
import FileMenu from './FileMenu';
import PopoverButton from './PopoverButton';
import ViewMenu from './ViewMenu';
import LabelsContent from './popovers/LabelsContent';
import LayoutContent from './popovers/LayoutContent';

interface Props {
  hasPresentButton?: boolean;
}

const ActionMenu: React.FC<Props> = ({ hasPresentButton }) => {
  const currentSankeyId = useCurrentRouteSankeyId();
  const { isFetching, isReadOnly } = useSankeyFormContext();

  return (
    <Box
      bg="gray.100"
      borderBottom="1px solid"
      borderBottomColor="gray.200"
      w="100%"
    >
      <HStack
        alignItems="center"
        justifyContent="space-between"
        maxW="var(--chakra-breakpoints-xxl)"
        mx="auto"
      >
        <Flex alignItems="center">
          <FileMenu />
          <ViewMenu />
          <PopoverButton label="Labels" disabled={isFetching || isReadOnly}>
            <LabelsContent />
          </PopoverButton>
          <PopoverButton label="Layout" disabled={isFetching || isReadOnly}>
            <LayoutContent />
          </PopoverButton>
          {hasPresentButton && (
            <Box ml={2}>
              <Tooltip content="View this diagram in presentation mode">
                <Link to={pathToSankeyPreview(currentSankeyId)}>
                  <Button
                    variant="primary-ghost"
                    background="transparent"
                    borderRadius="none"
                    size="sm"
                  >
                    <Icon icon="desktop" /> Present
                  </Button>
                </Link>
              </Tooltip>
            </Box>
          )}
        </Flex>
      </HStack>
    </Box>
  );
};

export default ActionMenu;
